module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v8.ff478a81.jpg";